import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import "./styles/globals.css";
import "./i18n/index.js";
import { AuroraBackground } from "./components/layout/AuroraBackground.js";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root");
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <div className="relative min-h-screen">
          <AuroraBackground />
          <div className="relative z-10 min-h-screen">
            <App />
          </div>
        </div>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
